<template>
  <v-row class="pt-4" no-gutters>
    <v-col>
      <v-row no-gutters>
        <span class="checkout-h3 accent--text">
          {{ $t("finished.courtesy") }}
        </span>
      </v-row>
      <v-row no-gutters>
        <span class="checkout-h4 grey--text">
          {{ $t("finished.courtesyText") }}
        </span>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>
